import axiosInstance from '../lib/api/axiosInstance';

export interface NoConsentFilters {
  startDate?: string;
  endDate?: string;
  sites?: string[];
}

export interface NoConsentData {
  date: string;
  organicClicks: number;
  paidPvs: number;
  organicPvs: number;
  paidReqs: number;
  organicReqs: number;
  revenue: number;
  paidClicks: number;
  paidBlockedReqs: number;
  paidBlockedPvs: number;
  viewabilityRate: number;
  paidViewabilityRate: number;
  organicViewabilityRate: number;
  videoRevenue: number;
  videoPlays: number;
}

export interface NoConsentSummary {
  totalRevenue: number;
  totalViews: number;
  totalClicks: number;
  averageViewability: number;
  videoRevenue: number;
  videoPlays: number;
}

export interface NoConsentDashboardData {
  summary: NoConsentSummary;
  dailyMetrics: NoConsentData[];
  sites: string[];
}

export interface NoConsentFilterOptions {
  sites: string[];
  dateRange: {
    minDate: string;
    maxDate: string;
  };
}

// Récupérer les données du dashboard No Consent
export const getNoConsentDashboardData = async (filters?: NoConsentFilters) => {
  const params = new URLSearchParams();
  
  if (filters?.startDate) {
    params.append('startDate', filters.startDate);
  }
  
  if (filters?.endDate) {
    params.append('endDate', filters.endDate);
  }
  
  if (filters?.sites && filters.sites.length > 0) {
    filters.sites.forEach(site => {
      params.append('sites', site);
    });
  }

  const response = await axiosInstance.get(`/no-consent/dashboard?${params.toString()}`);
  return response.data;
};

// Récupérer les options de filtres pour No Consent
export const getNoConsentFilterOptions = async () => {
  const response = await axiosInstance.get('/no-consent/filter-options');
  return response.data;
};